import React from 'react';
import { Link } from 'react-router-dom';
import SEOHelmet from '../components/SEOHelmet';

/**
 * 404 catch-all. Previously any unknown URL (including several dead footer
 * links) rendered a blank Layout shell. This gives a branded, helpful page
 * with routes back into the site.
 */
const NotFound: React.FC = () => {
  return (
    <div className="min-h-[70vh] bg-gradient-to-br from-gray-50 via-white to-orange-50 flex items-center justify-center px-4 py-16">
      <SEOHelmet
        title="Page not found | 12and22"
        description="The page you are looking for could not be found."
        canonicalUrl="https://12and22.com/404"
      />
      <div className="max-w-lg w-full text-center">
        <div className="text-primary-navy font-extrabold tracking-tight leading-none"
             style={{ fontSize: 'clamp(72px, 16vw, 128px)' }}>
          4<span className="text-secondary-500">0</span>4
        </div>
        <h1 className="mt-2 text-2xl font-bold text-gray-900">This page doesn&apos;t exist</h1>
        <p className="mt-3 text-gray-600">
          The link may be broken or the page may have moved. Let&apos;s get you back on track.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-block bg-primary-navy text-white font-semibold px-6 py-3 rounded-lg hover:bg-opacity-90 transition"
          >
            Back to home
          </Link>
          <Link
            to="/contact"
            className="inline-block bg-white text-primary-navy font-semibold px-6 py-3 rounded-lg border border-gray-200 hover:bg-gray-50 transition"
          >
            Contact support
          </Link>
        </div>

        <div className="mt-10 text-sm text-gray-500">
          <span className="mr-2">Popular:</span>
          <Link to="/hosting" className="text-primary-navy hover:underline mx-2">Web Hosting</Link>
          <Link to="/domains" className="text-primary-navy hover:underline mx-2">Domains</Link>
          <Link to="/vps" className="text-primary-navy hover:underline mx-2">VPS</Link>
          <Link to="/email" className="text-primary-navy hover:underline mx-2">Business Email</Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
